<template>
  <div class="fixed w-full h-screen top-0 left-0 flex justify-center py-10" style="z-index: 100;background-color:rgba(0,0,0,.5)" @click="closeModal">
    <div  class="lg:w-[70%] w-11/12 h-full m-auto bg-white border border-black shadow-lg cursor-pointer overflow-y-auto flex flex-col justify-between" style="z-index: 9999;">

      <div class="flex justify-between w-full p-4 border">
        <p class=" my-auto font-bold text-xl w-full">{{title}}</p>
        <img src="@/assets/img/close.png" class="w-4 h-4 ml-2 my-auto" @click="closeModal"/>
      </div>
      <div class="flex flex-col text-center justify-between w-full p-4">
        <img v-if="img != '' && img != null" :src="imgUrl(img, 'modal_pictures')" class="m-auto mb-4 lg:max-w-[90%] max-h-[900px]" alt="image-modale" >
      </div>
      <div class="flex justify-end w-full p-4 border">
        <button class="p-2 rounded-lg text-white my-auto bg-grey font_bold" @click="closeModal">Fermer</button>
      </div>
      
    </div>

    
  </div>
</template>

<script>
import { Field } from 'vee-validate'

export default {
  emits: ['closeModal'],
  components: {
    Field
  },
  props: {
    title: [String],
    img : [String]
  },
  data: () => ({}),
  methods: {
    closeModal(){
      this.$emit('closeModal')
    },
  },
  computed: {
  },
  created() {
    
  }
}
</script>

<style scoped>
</style>
